/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-uses-react */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/prop-types */
import { createContext, useState } from "react";
import moment from "moment";

const DateTimeRangeContext = createContext();

export const DateTimeRangeProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(1, "day"));
  const [lastActive, setLastActive] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const handleSetInitialized = () => {
    setInitialized(true);
  };

  const handleSetStartDate = (arg = null) => {
    if (arg != null) {
      setStartDate(arg);
    }
  };

  const handleSetLastActive = (arg = null) => {
    if (arg != null) {
      setLastActive(arg);
    }
  };

  const handleSetEndDate = (arg = null) => {
    if (arg != null) {
      setEndDate(arg);
    }
  };

  return (
    <DateTimeRangeContext.Provider
      value={{
        initialized,
        startDate,
        lastActive,
        endDate,
        handleSetInitialized,
        handleSetStartDate,
        handleSetLastActive,
        handleSetEndDate,
      }}
    >
      {children}
    </DateTimeRangeContext.Provider>
  );
};

export default DateTimeRangeContext;
